// The reducer that holds graph data information.
// @flow
import { ACTIONS } from '../actions';
import type { KpiState } from '../constants';

type Action = {
    kpi: KpiState,
    type: string
};

export const kpi = (
    state: KpiState = null,
    action: Action = {
        type: '',
        kpi: null
    }
): KpiState => {
    switch (action.type) {
        case ACTIONS.INITIALIZE:
            if (action.kpi) {
                return [...action.kpi];
            }
            return null;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducer/analytics/reducers/kpi.js